import { useRegionStore } from '@/store-pinia/region'

export default defineNuxtRouteMiddleware(async () => {
  const { $pinia, $store: store, $dayjs } = useNuxtApp()

  const regionStore = useRegionStore($pinia)

  const timeZone = $dayjs.tz.guess()
  const regionDetectPayload = { ip: store.getters.userIpAddress, timeZone }

  const apiRequests = [...(!regionStore.regionDetectInfo ? [regionStore.fetchRegionDetect(regionDetectPayload)] : [])]

  if (apiRequests.length > 0) {
    await Promise.all(apiRequests)
  }
})
